import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '/home/artist/recom/list',
        method: 'get',
        params:data
    })
}
